import React from "react";
import type { FC, PropsWithChildren } from "react";
import PatientStyle from "../../styles/Patient.module.css";
import SelectInputBox from "../../components/Modal/SelectInputBox";
import { IAssociatedClinic } from "../../hooks/patients/index.type";
import { useFetchBillingProvider } from "../../hooks/patients";
import { IaddPatientModalStates, IntakeFormQuestion } from "./AddPatientModal";
import { InputField } from "../../components/Modal";
import EnrollPatientStyle from "../../styles/EnrollPatient.module.css";
import CheckboxInput from "../../components/Modal/CheckBoxInput";

export type AddPatientModalState = PropsWithChildren<{
  status: boolean;
}>;

type AddEditModalProps = PropsWithChildren<{
  addEditModalStates: IaddPatientModalStates;
  setAddEditModalStates: React.Dispatch<
    React.SetStateAction<IaddPatientModalStates>
  >;
  billingProvider?: string[];
  billingProviderLoading?: boolean;
  associatedClinic?: IAssociatedClinic[];
  associatedClinicLoading?: boolean;
  isUpdateMode?: boolean;
}>;

const ClinicInfoModal: FC<AddEditModalProps> = (props) => {
  const [selectedAssociatedClinic, setSelectedAssociatedClinic] =
    React.useState<string>(props.addEditModalStates.associatedClinic.value);
  const { billingProvider, billingProviderLoading, getBillingProvider } =
    useFetchBillingProvider({
      selectedAssociatedClinicId: selectedAssociatedClinic || "",
    });

  React.useEffect(() => {
    if (selectedAssociatedClinic) {
      getBillingProvider();
    }
  }, [selectedAssociatedClinic]);

  React.useEffect(() => {
    if (props.addEditModalStates.associatedClinic.value) {
      setSelectedAssociatedClinic(
        props.addEditModalStates.associatedClinic.value
      );
    }
  }, [props.addEditModalStates.associatedClinic.value]);
  return (
    <>
      <SelectInputBox
        name="associated-clinic"
        label="Associated Clinic"
        value={props.addEditModalStates.associatedClinic.value}
        onChange={(event) => {
          setSelectedAssociatedClinic(event.target.value);

          props.setAddEditModalStates((prevVal) => ({
            ...prevVal,
            associatedClinic: { value: event.target.value, error: "" },
          }));
        }}
        errorMessage={props.addEditModalStates.associatedClinic.error}
        customClass={PatientStyle.custom_select_box}
        disable={props.isUpdateMode}
        inputContainerStyle={{ maxWidth: "100%", paddingBottom: "1rem" }}
        containerClass={EnrollPatientStyle.enrollInput}
        labelClass={EnrollPatientStyle.enrollInputLabel}
      >
        <option value="" className={PatientStyle.custom_option}>
          Select Clinic
        </option>
        {props.associatedClinicLoading ? (
          <option disabled>Loading Clinic...</option>
        ) : (
          props.associatedClinic?.map((clinic) => (
            <option key={clinic._id} value={clinic._id}>
              {clinic.name}
            </option>
          ))
        )}
      </SelectInputBox>
      <SelectInputBox
        name="billing-provider"
        label="Billing Provider"
        value={props.addEditModalStates.billingProvider.value}
        customClass={PatientStyle.custom_select_box}
        onChange={(event) => {
          props.setAddEditModalStates((prevVal) => ({
            ...prevVal,
            billingProvider: { value: event.target.value, error: "" },
          }));
        }}
        disable={props.isUpdateMode}
        errorMessage={props.addEditModalStates.billingProvider.error}
        inputContainerStyle={{ maxWidth: "100%", paddingBottom: "1rem" }}
        containerClass={EnrollPatientStyle.enrollInput}
        labelClass={EnrollPatientStyle.enrollInputLabel}
      >
        <option value="" className={PatientStyle.custom_option}>
          Select Provider
        </option>
        {billingProviderLoading ? (
          <option disabled>Loading Provider...</option>
        ) : (
          billingProvider?.map((provider) => (
            <option key={provider._id} value={provider._id}>
              {provider.name}
            </option>
          ))
        )}
      </SelectInputBox>
      <InputField
        label="Best time to contact (Optional)"
        value={props.addEditModalStates.bestTimeToContact.value}
        onChange={(event) => {
          props.setAddEditModalStates((prevVal) => ({
            ...prevVal,
            bestTimeToContact: { value: event.target.value, error: "" },
          }));
        }}
        errorMessage={props.addEditModalStates.bestTimeToContact.error}
        style={{ maxWidth: "100%" }}
        customClass={EnrollPatientStyle.enrollInput}
        containerClass={EnrollPatientStyle.enrollInputContainer}
        labelClass={EnrollPatientStyle.enrollInputLabel}
      />
      {props.isUpdateMode && (
        <div className={EnrollPatientStyle.enrollInputContainer} style={{display: "flex", flexDirection: "column", gap: "0.5rem"}}> 
        <CheckboxInput
        label="Red Flag (Optional)"
        checked={props.addEditModalStates.rtmRedFlag.value === "yes" ? true : false}
        onChange={(event) => {
          props.setAddEditModalStates((prevVal) => ({
            ...prevVal,
            rtmRedFlag: { value: event.target.checked ? "yes" : "no", error: "" },
            rtmRedFlagReason: event.target.checked 
              ? prevVal.rtmRedFlagReason 
              : { value: "", error: "" },
          }));
        }}
        labelClass={EnrollPatientStyle.enrollcheckboxInputLabel}
      />
        <InputField
        placeholder="Reason"
        value={props.addEditModalStates.rtmRedFlagReason?.value || ""}
        onChange={(event) => {
          props.setAddEditModalStates((prevVal) => ({
            ...prevVal,
              rtmRedFlagReason: { value: event.target.value, error: "" },
          }));
        }}
        errorMessage={props.addEditModalStates.rtmRedFlagReason?.error}
        style={{ maxWidth: "100%" }}
        customClass={EnrollPatientStyle.enrollInput}
        containerClass={EnrollPatientStyle.enrollInputContainer}
       
      />
        </div>
   
      )}
    </>
  );
};

export default ClinicInfoModal;
